<template>
    <div :class="['shadow', 'gp-nummern', 'drei_60-border-1', border]">
        <div :class="['gp-nummern__icon', background]">
            <v-icon class="drei_60-white-text">{{ icon }}</v-icon>
        </div>
        <div>
            <div class="text-uppercase gp-nummern__title mb-2">
                <v-tooltip :top="true">
                    <template v-slot:activator="{ on }">
                        <span v-on="on">GP-Nummern</span>
                    </template>
                    <div class="max-width-btn">
                        Die GP-Nummer verknüpft das SAP- und SSO-Konto des Nutzers und ermöglich das Kundenprofil mit den Produkten zu koppeln.
                        Besitzt ein Nutzer keine GP-Nummer gab es entweder einen Fehler im Registrierungsprozess oder der Nutzer ist noch kein Kunde (zum Beispiel weil Print-Kunden ihr Abo
                        um oder auf ein digitales Abo erweitern oder umstellen oder aber weil sie sich bei der Eingabe der Kundennummer im Registrierungsprozess vertippt haben).
                    </div>
                </v-tooltip>
                <v-spacer></v-spacer>
                <AddGpNummer :ssoId="ssoId" @reload="reload" :gpNummern="gpNummern" tooltipPosition="right" />
            </div>
            <hr>
            <div class="gp-nummern__nummern mt-2 font-weight-bold">
                <div v-for="(contractor, index) in gpNummern" :key="`gp-nummern__nummer-${index}`" :class="`gp-nummern__nummer-${index}`">
                    <div>{{ contractor.id }} ({{ contractor.scope }})</div>
                    <v-spacer v-if="isLeserserviceOrHigher"></v-spacer>
                    <DeleteGpNummer
                        v-if="isLeserserviceOrHigher"
                        :ssoId="ssoId"
                        :contractorId="contractor.id"
                        :contractorScope="contractor.scope"
                        :contractorOriginal="contractor.original"
                        @reload="reload"
                        tooltipPosition="right"
                    />
                </div>
                <div
                    v-if="!hasGps"
                    class="gp-nummern__no-gp"
                >
                    <p class="body-2 ma-0">Benutzer ist kein Geschäftspartner</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import DeleteGpNummer from '@/components/customer/DeleteGpNummer.vue';
import AddGpNummer from '@/components/customer/AddGpNummer.vue';

export default {
    name: 'GpNummer',
    props: ['ssoId', 'gpNummern', 'disabled'],
    components: {
        AddGpNummer,
        DeleteGpNummer,
    },
    data() {
        return {};
    },
    methods: {
        reload() {
            this.$emit('reload');
        },
    },
    computed: {
        ...mapGetters(['isLeserserviceOrHigher']),
        background() {
            return `drei_60-${this.color}`;
        },
        border() {
            return `drei_60-${this.color}-border`;
        },
        hasGps() {
            return this.gpNummern.length > 0;
        },
        color() {
            return this.hasGps ? 'green' : 'yellow';
        },
        icon() {
            return this.hasGps ? 'mdi-thumb-up' : 'mdi-thumb-down';
        },
    },
};

</script>
<style scoped lang="scss">

@import "@/style/colors.scss";

.gp-nummern {
    display: flex;
}
.gp-nummern__title {
    display: flex;
    align-items: center;
    margin-left: 10px;
    margin-right: 10px;
}

.gp-nummern__no-gp {
    padding: 5px 10px;
}

[class*="gp-nummern__nummer-"] {
    display: flex;
    align-items: center;
    padding: 5px 10px;
}
[class*="gp-nummern__nummer-"]:hover {
    background-color: $grey-dark-0;
    cursor: pointer;
}
.gp-nummern__icon {
    flex: none;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.gp-nummern__icon + div {
    flex: 1;
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    flex-direction: column;
}

</style>
